import { createSlice } from "@reduxjs/toolkit";
import { DisplayType } from "const";
import { cloneDeep } from "lodash";

const initialState = {
  loading: false,
  unitholders: [],
  assets: {},
  strategyList: [],
  fetchingStrategy: false,
  fetchingUnitHolder: false,
  mutualFundAsset: [],
  mutualFundAssetType: {},
  mutualFundAssetChart: {},
  filterUnitholder: [],
  modelPortDocument: null,
  strategy: {
    assets: [],
    activeStrategy: null,
    data: [],
    displayType: DisplayType.PERCENT,
    fundTypeSelected: null,
    mutualFundSpecificType: {
      fundList: [],
    },
  },
};

const slice = createSlice({
  initialState,
  name: "modelPortfolio",
  reducers: {
    reset: () => cloneDeep(initialState),
    getUnitholders: (state) => {
      if (state.unitholders.length === 0) {
        state.fetchingUnitHolder = true;
      }
    },
    getUnitholdersSuccess: (state, action) => {
      if (state.unitholders.length === 0) {
        state.filterUnitholder = [...action.payload.map((u) => u.unitholderNo)];
      }
      state.fetchingUnitHolder = false;
      state.unitholders = action.payload;
    },
    getUnitholdersFailure: (state) => {
      state.fetchingUnitHolder = false;
      state.assets = {};
    },
    setStrategyLoading: (state, action) => {
      state.fetchingStrategy = action.payload;
    },
    getAllocationMutualFund: (state) => {
      state.fetchingStrategy = true;
    },
    getAllocationMutualFundSuccess: (state, action) => {
      state.strategyList = action.payload;
      state.fetchingStrategy = false;
    },
    getAllocationMutualFundFailure: (state) => {
      state.strategyList = [];
      state.fetchingStrategy = false;
    },
    getAllocationMutualFundByUnitholder: () => {},
    getAllocationMutualFundByUnitholderSuccess: (state, action) => {
      state.fetchingStrategy = false;
      state.strategyList = action.payload.strategyList;
    },
    getAllocationMutualFundByUnitholderFailure: (state) => {
      state.fetchingStrategy = false;
      state.strategyList = [];
    },
    setAllocationFocus: (state, action) => {
      state.strategy.activeStrategy = action.payload;
    },
    setStrategy: (state, action) => {
      const data = action.payload;
      state.strategy = { ...data };
    },
    filterUnitholderChange: (state, action) => {
      state.filterUnitholder = action.payload;
    },
    setModelPortDocument: (state, action) => {
      state.modelPortDocument = action.payload;
    },
  },
});

export const {
  reset,
  setStrategyLoading,

  getUnitholders,
  getUnitholdersSuccess,
  getUnitholdersFailure,

  getAllocationMutualFund,
  getAllocationMutualFundSuccess,
  getAllocationMutualFundFailure,

  getAllocationMutualFundByUnitholder,
  getAllocationMutualFundByUnitholderSuccess,
  getAllocationMutualFundByUnitholderFailure,

  setAllocationFocus,
  setStrategy,
  filterUnitholderChange,
  setModelPortDocument,
} = slice.actions;

export default slice;
